<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import AuthOverlayGate from '@/components/layout/AuthOverlayGate.vue'

const route = useRoute()
const viewOwnsAuthGate = computed(() => route.meta.authGateScope === 'view')
</script>

<template>
  <div class="relative h-full w-full">
    <RouterView />
    <AuthOverlayGate v-if="!viewOwnsAuthGate" />
  </div>
</template>
